import { SECOND_MS } from '@mail-core/std';
import { xray } from 'lib/xray';
import type { GroupClearedInfo } from 'reactApp/api/quotaCleaner/QuotaCleanerAPICall.types';
import { fastCleanGroupsUpdate } from 'reactApp/modules/userQuotaCleaner/userQuotaCleaner.actions';
import { FastCleanSelectors } from 'reactApp/modules/userQuotaCleaner/userQuotaCleaner.selectors';
import type { QuotaCleaneFastGroup } from 'reactApp/modules/userQuotaCleaner/userQuotaCleaner.types';
import { store as reduxStore } from 'reactApp/store';
import { put, select } from 'redux-saga/effects';

const QUEUE_SAFE_SEC_TIMEOUT = 10;

type FastCleanFailResultType = 'no_clean' | 'remove_only' | 'remove_and_safe' | 'unexpected';
type FastCleanSuccessResultType = 'remove_only' | 'remove_and_safe';
export type FastCleanResultType = FastCleanFailResultType | FastCleanSuccessResultType;

export type FastCleanProcessReturnValueType = {
    status: boolean;
    result: FastCleanResultType;
    data: { totalCleared: number; overquotaBytes: number; expectedTotalCleared: number };
};

export const executeActionsQueue = (queue: ReturnType<typeof fastCleanGroupsUpdate>[], timeout: number) => {
    let i = 0;
    const myInterval = setInterval(() => {
        if (i >= queue.length) {
            clearInterval(myInterval);
            return;
        }

        reduxStore.dispatch(queue[i]);
        i++;
    }, timeout);
};

export function* saveFastCleanGroupsSuccess(groups: GroupClearedInfo[], executeActionsFunc = executeActionsQueue) {
    let maxSecondsLeft = 0;

    for (const group of groups) {
        const groupId = group.group_id;

        let secondsLeft = Math.ceil(
            group.result?.mail_moved_to_safe?.seconds_left ||
                group.result?.mail_deleted?.seconds_left ||
                group.result?.cloud_moved_to_safe?.seconds_left ||
                group.result?.cloud_deleted?.seconds_left ||
                0
        );

        // если очистка не асинхронная, сразу апдейтим стейт
        if (!secondsLeft) {
            yield put(
                fastCleanGroupsUpdate([
                    {
                        groupId,
                        cleared: group.result.total_cleared,
                    },
                ])
            );
            continue;
        }

        secondsLeft += QUEUE_SAFE_SEC_TIMEOUT;

        maxSecondsLeft = Math.max(maxSecondsLeft, secondsLeft);

        xray.send('quota-fast-cln-seconds-left', { dwh_enabled: true, dwh: { value: secondsLeft } });

        // если асинхронная, апдейтим равномерно в течение оставшегося времени (фейковая загрузка)

        const groupInfo: QuotaCleaneFastGroup | undefined = yield select(FastCleanSelectors.getGroup, groupId);

        const sizeStep = Math.ceil((groupInfo?.size_uniq || 0) / secondsLeft);
        const countStep = Math.ceil((group.result?.total_cleared?.count || 0) / secondsLeft);
        const stepAction = fastCleanGroupsUpdate([
            {
                groupId,
                cleared: {
                    size: sizeStep,
                    count: countStep,
                },
            },
        ]);
        const lastAction = fastCleanGroupsUpdate([
            {
                groupId,
                cleared: {
                    size: sizeStep,
                    count: countStep,
                },
                isSuccess: true,
            },
        ]);

        const actionsQueue = new Array(secondsLeft - 1).fill(stepAction).concat([lastAction]);

        executeActionsFunc(actionsQueue, SECOND_MS);
    }

    return maxSecondsLeft;
}
